var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconTag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.1667C18 12.6382 17.8127 13.0903 17.4793 13.4237C17.1459 13.7571 16.6937 13.9444 16.2222 13.9444H5.55556L2 17.5V3.27778C2 2.80628 2.1873 2.3541 2.5207 2.0207C2.8541 1.6873 3.30628 1.5 3.77778 1.5H16.2222C16.6937 1.5 17.1459 1.6873 17.4793 2.0207C17.8127 2.3541 18 2.80628 18 3.27778V12.1667Z",
    stroke: "#EF7709",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconTag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconTag.8c5e49a8.svg";
export { ForwardRef as ReactComponent };